import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import FormContext from "../context/formContext";
import BackLogout from "../component/backLogout";
import { useToast } from "@chakra-ui/react";

const FormPreview = () => {
  const toast = useToast();
  const navigate = useNavigate();
  const context = useContext(FormContext);
  const { loginObj, setLoginObj } = context;

  // eslint-disable-next-line
  const [base_url, setBase_Url] = useState(
    "https://erpapi.eshiksa.net/Gadvasu"
  );

  useEffect(() => {
    window.scrollTo(0, 0);

    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Cookie", "ci_session=ks1r6e3hp01h9psp1ufu608e45l56ri4");
    myHeaders.append("auth_token", localStorage.getItem("token"));
    var raw = JSON.stringify({
      Branch_id: "1763",
      student_id: localStorage.getItem("studentId"),
      db_name: "erp_eshiksa",
      email: localStorage.getItem("email"),
    });

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };

    fetch(
      "https://erpapi.eshiksa.net/Gadvasu/getStudentData.php",
      requestOptions
    )
      .then((response) => response.text())
      .then((result) => {
        var resultObj = JSON.parse(result);
        // console.log(resultObj);

        if (resultObj.success === 1) {
          setLoginObj(resultObj.form_data);
        } else {
          toast({
            title: "Alert",
            description: resultObj.msg,
            status: "error",
            duration: 1000,
            isClosable: true,
            position: "top",
          });
        }
      })
      .catch((error) => console.log("error", error));
    // eslint-disable-next-line
  }, []);

  return (
    <React.Fragment>
      <div className="container">
        <div>
          <button
            className="btn btn-sm my-2 "
            style={{ border: "1px solid #a6191f", color: "#a6191f" }}
          >
            {" "}
            <i class="fa-solid fa-user mx-2"> </i>
            {loginObj.name}
          </button>

          <BackLogout />
        </div>

        <div className="row border border-3 rounded-3 my-3">
          <div className="p-0">
            <div className="w-100 p-1 pt-2 px-3 form_input_header">
              <h6 className="text-light text-center"> Form Preview</h6>
            </div>
          </div>
          <div className="row mx-auto mt-3">
            <div className="col-4 border ">
              <p>Are you a resident of Punjab or Chandigarh(U.T)</p>
            </div>
            <div className="col-2 border border">
              <p>{loginObj.resident}</p>
            </div>

            {loginObj.resident === "Yes" ? (
              <>
                <div className="col-4 border ">
                  <p>Caste Category</p>
                </div>
                <div className="col-2 border border">
                  {loginObj.student_Category}
                </div>
              </>
            ) : (
              <>
                <div className="col-4 border ">
                  <p>Selected State</p>
                </div>
                <div className="col-2 border border">
                  <p>{loginObj.stateName}</p>
                </div>
              </>
            )}
          </div>

          <div className="row mx-auto">
            <div className="col-4 border ">
              <p>Studied at +2 Level</p>
            </div>
            <div className="col-2 border border">
            {loginObj.twlStream !== "Other" ? (
                <p>{loginObj.twlStream}</p>
              ) : (
                <p>{loginObj.OtherStreamName}</p>
              )} 
            </div>
            <div className="col-4 border">
              <p>Programme Applied for</p>
            </div>
            <div className="col-2 border">
              <p>{loginObj.pmgApplied}</p>
            </div>
          </div>

          <div className="row mx-auto">
            <div className="col-4 border">
              <p>Undergraduate-Programme</p>
            </div>
            <div className="col-2 border">
              <p>{loginObj.streamSelected}</p>
            </div>
          </div>

          <div className="row mx-auto">
            <div className="col-4 border">
              <p>Name of the Applicant</p>
            </div>
            <div className="col-2 border">
              <p>{loginObj.name}</p>
            </div>
            <div className="col-4 border">
              <p>Email</p>
            </div>
            <div className="col-2 border">
              <p>{loginObj.email}</p>
            </div>
          </div>

          <div className="row mx-auto">
            <div className="col-4 border">
              <p>Mobile Number</p>
            </div>
            <div className="col-2 border">
              <p>{loginObj.mobile_no}</p>
            </div>
            <div className="col-4 border">
              <p>Gender</p>
            </div>
            <div className="col-2 border">
              <p>{loginObj.gender}</p>
            </div>
          </div>

          <div className="row mx-auto">
            <div className="col-4 border">
              <p>Date of Birth</p>
            </div>
            <div className="col-2 border">
              <p>{loginObj.DOB}</p>
            </div>
            <div className="col-4 border">
              <p>Age</p>
            </div>
            <div className="col-2 border">
              <p>{loginObj.age}</p>
            </div>
          </div>

          <div className="row mx-auto">
            <div className="col-4 border">
              <p>Father's Name</p>
            </div>
            <div className="col-2 border">
              <p>{loginObj.father_name}</p>
            </div>
            <div className="col-4 border">
              <p>Mother's Name</p>
            </div>
            <div className="col-2 border">
              <p>{loginObj.mother_name}</p>
            </div>
          </div>

          <div className="row mx-auto">
            <div className="col-4 border">
              <p>Religion</p>
            </div>
            <div className="col-2 border">
              <p>{loginObj.religion}</p>
            </div>
            {/* <div className="col-4 border">
              <p>Whether belong to Kashmiri Migrant Category ?</p>
            </div>
            <div className="col-2 border">
              <p>{loginObj.whetherfromKM}</p>
            </div> */}
          </div>

          {loginObj.resident === "Yes" && (
            <>
              <div className="row mx-auto">
                <div className="col-4 border">
                  <p>Are you a Sports Person</p>
                </div>
                <div className="col-2 border">
                  <p>{loginObj.isSports}</p>
                </div>
                {loginObj.sportsCategory && (
                  <>
                    <div className="col-4 border">
                      <p>Game Played in last qualified exam</p>
                    </div>
                    <div className="col-2 border">
                      <p>{loginObj.sportsCategory}</p>
                    </div>
                  </>
                )}
              </div>

              {/* <div className="row mx-auto">
                <div className="col-4 border">
                  <p>Whether belongs to Freedom Fighter Category?</p>
                </div>
                <div className="col-2 border">
                  <p>{loginObj.whetherFreedomF}</p>
                </div>
                <div className="col-4 border">
                  <p>Whether belongs to Armed Force Category?</p>
                </div>
                <div className="col-2 border">
                  <p>{loginObj.whetherArmedF}</p>
                </div>
              </div> */}

              <div className="row mx-auto">
                <div className="col-4 border">
                  <p>Whether belongs to Terrorist Affected Category?</p>
                </div>
                <div className="col-2 border">
                  <p>{loginObj.whetherTerrorAffctd}</p>
                </div>
                <div className="col-4 border">
                  <p>Whether belongs to Border Area Category?</p>
                </div>
                <div className="col-2 border">
                  <p>{loginObj.whetherBorderArea}</p>
                </div>
              </div>

              <div className="row mx-auto">
                <div className="col-4 border">
                  <p>Whether belongs to Rural Area Category?</p>
                </div>
                <div className="col-2 border">
                  <p>{loginObj.whetherRuralArea}</p>
                </div>
              </div>
            </>
          )}

          <div className="row mx-auto">
            <div className="col-4 border">
              <p>Whether belongs to Disabled Person Category?</p>
            </div>
            <div className="col-2 border">
              <p>{loginObj.whetherDisabled}</p>
            </div>
            {loginObj.aadharNo && (
              <>
                <div className="col-4 border">
                  <p>Aadhaar No</p>
                </div>
                <div className="col-2 border">
                  <p>{loginObj.aadharNo}</p>
                </div>
              </>
            )}
          </div>

          <div className="row mx-auto">
            <div className="col-4 border">
              <p>Address Line 1</p>
            </div>
            <div className="col-2 border">
              <p>{loginObj.addLine1}</p>
            </div>

            {loginObj.addLine2 && (
              <>
                <div className="col-4 border">
                  <p>Address Line 2</p>
                </div>
                <div className="col-2 border">
                  <p>{loginObj.addLine2}</p>
                </div>
              </>
            )}
          </div>

          <div className="row mx-auto">
            <div className="col-4 border">
              <p>City</p>
            </div>
            <div className="col-2 border">
              <p>{loginObj.city}</p>
            </div>

            <div className="col-4 border">
              <p>Country</p>
            </div>
            <div className="col-2 border">
              <p>{loginObj.country}</p>
            </div>
          </div>

          <div className="row mx-auto">
            <div className="col-4 border">
              <p>State/Province</p>
            </div>
            <div className="col-2 border">
              <p>{loginObj.stateNameAdd}</p>
            </div>

            <div className="col-4 border">
              <p>Postal code</p>
            </div>
            <div className="col-2 border">
              <p>{loginObj.postalCode}</p>
            </div>
          </div>

          <div className="row mx-auto">
            <div className="col-4 border">
              <p>Name of the School- 10th</p>
            </div>
            <div className="col-2 border">
              <p>{loginObj.tenSchoolName}</p>
            </div>

            <div className="col-4 border">
              <p>Board- 10th</p>
            </div>
            <div className="col-2 border">
              <p>{loginObj.tenSchoolBoard}</p>
            </div>
          </div>

          <div className="row mx-auto">
            <div className="col-4 border">
              <p>Year of Passing - 10th</p>
            </div>
            <div className="col-2 border">
              <p>{loginObj.tenPassYear}</p>
            </div>

            <div className="col-4 border">
              <p>Percentage - 10th</p>
            </div>
            <div className="col-2 border">
              <p>{loginObj.tenMarksPercent}</p>
            </div>
          </div>

          <div className="row mx-auto">
            <div className="col-4 border">
              <p>Name of the Institute- 12th</p>
            </div>
            <div className="col-2 border">
              <p>{loginObj.twlSchoolName}</p>
            </div>

            <div className="col-4 border">
              <p>Board- 12th</p>
            </div>
            <div className="col-2 border">
              <p>{loginObj.twlBoardName}</p>
            </div>
          </div>

          <div className="row mx-auto">
            <div className="col-4 border">
              <p>Year of Passing - 12th</p>
            </div>
            <div className="col-2 border">
              <p>{loginObj.twlPassYear}</p>
            </div>

            <div className="col-4 border">
              <p>Exam Status-12th</p>
            </div>
            <div className="col-2 border">
              <p>{loginObj.twlExamStatus}</p>
            </div>
          </div>

          <div className="row mx-auto">
            <div className="col-4 border">
              <p>Stream</p>
            </div>
            <div className="col-2 border">
              {loginObj.twlStream !== "Other" ? (
                <p>{loginObj.twlStream}</p>
              ) : (
                <p>{loginObj.OtherStreamName}</p>
              )}  
            </div>
            <div className="col-4 border">
              <p>Maximum/Total Marks (As per 10+2 DMC)</p>
            </div>
            <div className="col-2 border">
              <p>{loginObj.twlMaxMarks}</p>
            </div>
          </div>

          <div className="row mx-auto">
            <div className="col-4 border">
              <p>Marks Obtained (As per 10+2 DMC)</p>
            </div>
            <div className="col-2 border">
              <p>{loginObj.twlObtainedMarks}</p>
            </div>

            <div className="col-4 border">
              <p>Percentage - 12th</p>
            </div>
            <div className="col-2 border">
              <p>{loginObj.twlMarksPercent}</p>
            </div>
          </div>
        

          <div className="row mx-auto mt-3">
            <dir className="col-2 border">
              <p>Photograph</p>
            </dir>
            <dir className="col-4 border">
              <img
                className="rounded"
                src={base_url + loginObj.photograph}
                alt=""
              />
            </dir>
            <dir className="col-2 border">
              <p>Signature of Applicant</p>
            </dir>
            <dir className="col-4 border">
              <img
                className="rounded"
                src={base_url + loginObj.signature}
                alt=""
              />
            </dir>
          </div>

          <div className="row mx-auto mt-3">
            <dir className="col-2 border">
              <p>Left Thumb Impression</p>
            </dir>
            <dir className="col-4 border">
              <img
                className="rounded"
                src={base_url + loginObj.left_thumb}
                alt=""
              />
            </dir>
            <dir className="col-2 border">
              <p>10 + 2 Marksheet</p>
            </dir>
            <dir className="col-4 border">
              <img
                className="rounded"
                src={base_url + loginObj.senior_marksheet}
                alt=""
              />
            </dir>
          </div>
        </div>

        <div className="row justify-content-around my-5">
          <input
            type="button"
            className="btn btn-primary w-25"
            onClick={() => navigate("/Payment")}
            value={"Go to payment"}
          />
        </div>
      </div>
    </React.Fragment>
  );
};

export default FormPreview;
